import { render } from "./Brand.vue?vue&type=template&id=2adfadb1&scoped=true"
import script from "./Brand.vue?vue&type=script&lang=js"
export * from "./Brand.vue?vue&type=script&lang=js"

import "./Brand.vue?vue&type=style&index=0&id=2adfadb1&scoped=true&lang=css"

import exportComponent from "/Users/ginea/Desktop/template_demo/vuejs-tailwindcss-portfolio-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2adfadb1"]])

export default __exports__